// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__b1GE1","signatureButtonsRight":"ModalSign_signatureButtonsRight__FmG1g"};